export class ReportSubscriptionsAdditionalRecipientController {
  onAddRecipient(recipient, form) {
    form.$setSubmitted();

    if (form.$invalid || recipient === '') {
      return;
    }

    this.newRecipient = '';
    form.$setPristine();
    form.$setUntouched();
    this.applyRecipient({ recipient });
  }
}



// WEBPACK FOOTER //
// ./src/modules/report-subscriptions/components/additional-recipients/additional-recipients-controller.js